import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router';
import { CALCS_PER_PAGE, CALC_NAMES, CALC_PAGE_TYPES, CALC_TYPES } from 'utils/calculatorUtils';
import CalcAccordion from '../../../components/CalcAccordion/CalcAccordion';
import CalcIcon from '../../../components/CalcIcon/CalcIcon';
import CalcFilter from '../../../components/CalcFilter/CalcFilter';
import CalcAssessment from '../../../components/CalcAssessment/CalcAssessment';
import CalcEmptyListBlock from '../../../components/CalcEmptyListBlock/CalcEmptyListBlock';
import { getResults as getCalculatorResult } from 'api/calc/endpoints/calc';
import { Loader } from 'tt-ui-lib/core';
import { useSelectedContext } from 'context/contextSelector';

const benchmarkTypes = [
  [CALC_TYPES.CARBON, CALC_TYPES.PROJECT],
  [CALC_TYPES.LOCAL],
  [CALC_TYPES.GLOBAL],
];

const Score = ({ targetWidth }) => {
  const { selectedCompany: widjetCompany } = useSelectedContext((context) => context.user);
  const { pathname } = useLocation();

  const [assessments, setAssessments] = useState([]);
  const [searchedAssessments, setSearchedAssessments] = useState([]);
  const [loading, setLoading] = useState(true);

  const RenewCalcResultList = () => {
    setLoading(true);
    getCalculatorResult()
      .then((res) => {
        const { data } = res.data;
        setAssessments(data);
        setSearchedAssessments(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    RenewCalcResultList();
  }, [pathname]);

  const updateAssessmentName = (id, newName) => {
    setAssessments((prev) => prev.map((a) => (a.id === id ? { ...a, name: newName } : a)));
    setSearchedAssessments((prev) => prev.map((a) => (a.id === id ? { ...a, name: newName } : a)));
  };
  const companyAssessments =
    widjetCompany && widjetCompany.selectedCompany
      ? assessments.filter((el) => el.companyId === widjetCompany.selectedCompany.id)
      : assessments;

  return (
    <>
      {companyAssessments.length > 0 ? (
        <>
          <CalcFilter setSearchedItems={setSearchedAssessments} items={companyAssessments} />
          {benchmarkTypes.map((arr) => (
            <>
              {searchedAssessments.some((asses) => arr.includes(asses.type)) && (
                <div key={arr[0]}>
                  <CalcAccordion logo={<CalcIcon type={arr[0]} />} title={CALC_NAMES[arr[0]]}>
                    {searchedAssessments
                      .filter((assessment) => arr.includes(assessment.type))
                      .map((assessment) => (
                        <div key={assessment.id}>
                          <CalcAssessment
                            targetWidth={targetWidth}
                            assessment={assessment}
                            updateAssessmentName={updateAssessmentName}
                          />
                        </div>
                      ))}
                  </CalcAccordion>
                </div>
              )}
            </>
          ))}
        </>
      ) : loading ? (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Loader />
        </div>
      ) : (
        <CalcEmptyListBlock collectionName="results" />
      )}
    </>
  );
};

export default Score;
